import { Component, Input } from "@angular/core";
import { RepositoryFormData } from "../../../interfaces";
import { CardGroup } from "./cardList.component";
import { ICardListGridViewMetadata } from "@tylertech/tyler-api-types";

@Component({
    selector: "card-list-group",
    templateUrl: "./cardListGroup.tmpl.html",
    standalone: false
})
export class CardListGroupComponent
{
    @Input()
    view: ICardListGridViewMetadata;

    @Input()
    groups: CardGroup[];

    @Input()
    datacontroller: RepositoryFormData;

    @Input()
    hasBody: boolean;

    @Input()
    readonly depth: number = 0;

    isOpen(group: CardGroup): boolean
    {
        return group.Open;
    }

    toggle($event, group: CardGroup): void
    {
        if (this.hasOpenChild($event, group) && $event.currentTarget.open)
            group.Open = true;
        else
            group.Open = !group.Open;
        if (group.Entities)
            group.Entities.forEach(e => e["$cardVisible"] = group.Open);
    }

    hasOpenChild($event, group: CardGroup): boolean
    {
        if (!group.Groups)
            return $event.currentTarget.open;
        let hasOpen = false;
        group.Groups.forEach(g =>
        {
            if (this.hasOpenChild($event, g))
                hasOpen = true;
        });
        return hasOpen;
    }
}
